var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-help"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help",
    clipPath: "url(#clip-help)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15830",
    "data-name": "Group 15830",
    transform: "translate(-534 -665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_663",
    "data-name": "Ellipse 663",
    transform: "translate(536 667)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18066",
    "data-name": "Path 18066",
    d: "M95.155,54.311A3.485,3.485,0,0,0,93.6,57.779c0,.527-.277,1.137-1.637,1.137-1.137,0-1.526-.416-1.526-1.859A5.079,5.079,0,0,1,92.3,52.84c.916-.777,2.469-1.637,2.469-3.135,0-1.276-1.11-1.887-2.5-1.887-2.83,0-2.22,2.137-3.718,2.137a1.591,1.591,0,0,1-1.665-1.582c0-1.5,1.72-3.718,5.466-3.718,3.552,0,5.91,1.97,5.91,4.578S95.9,53.728,95.155,54.311Zm-1.027,8.657A2.155,2.155,0,0,1,91.992,65.1a2.137,2.137,0,0,1,0-4.273A2.156,2.156,0,0,1,94.129,62.968Z",
    transform: "translate(461.446 630.176)",
    fill: "#5c6d7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b9ea92a22d1881d0250ecb4d7becdd6b.svg";
export { ForwardRef as ReactComponent };